import { render, staticRenderFns } from "./ModalImportTabsLayers.vue?vue&type=template&id=f041ade0"
import script from "./ModalImportTabsLayers.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalImportTabsLayers.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports